module.exports = __webpack_public_path__ + "static/media/note-icon.314e53e2.svg";